exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xterm.fullscreen{position:fixed;top:0;bottom:0;left:0;right:0;width:auto;height:auto;z-index:255}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/xterm/lib/addons/fullscreen/fullscreen.css
// module id = 24
// module chunks = 0